import { Div } from "components/Base";
import React from "react";
import Session from "Portal/NewPortal/Sections/Home/Cards/Sessions/Session";
import { noop } from "utils/General";

const DUMMY_SESSION_2 = {
  openSessionFlyover: noop,
  id: "97a0ede9-0697-4dec-8e35-f584921ceefd",
  status: "approved",
  name: "123",
  open_label: "Accepted",
  original_status: "accepted",
  is_past_due: false,
  is_submitter: false,
  isReadOnly: false,
  meta: {
    friendly_id: "ABST-125",
    url:
      "/submit/taras-new-conference/40d0371e-7802-4f88-8d03-e16d26e3b2d0/submissions/97a0ede9-0697-4dec-8e35-f584921ceefd",
    speakers: "",
    track: "2-Test Track",
    format: "Test",
    level: "Advanced 234",
    starts_at: "2024-03-26T06:16:00.000Z",
    ends_at: "2024-03-28T03:55:00.000Z",
    date: "Tue, Mar 26th, 2:16am - Wed, Mar 27th, 11:55pm",
    location: "BABC",
    chairpersons: "",
    moderators: "",
    sponsors:
      "aerg aeg ae4t q34 gerg esrg esrg, aerg aerg aeg ae gae, tarar, Test Platimum Sponsor",
    exhibitors: "",
    count_of_files: 78,
    count_of_comments: 0,
    ceu_credits: null
  },
  subsessions: [
    {
      id: "8619ae20-52e4-4cc7-9e5b-7baee3e4c3ca",
      name: "sub 2.1",
      is_past_due: false,
      parent_session_id: "97a0ede9-0697-4dec-8e35-f584921ceefd",
      isReadOnly: false,
      isSubsession: true,
      meta: {
        friendly_id: "ABST-125-2",
        starts_at: "2023-02-27T16:46:00.000Z",
        count_of_files: 0,
        ends_at: "2023-02-27T17:00:00.000Z",
        url:
          "/submit/taras-new-conference/40d0371e-7802-4f88-8d03-e16d26e3b2d0/submissions/8619ae20-52e4-4cc7-9e5b-7baee3e4c3ca",
        date: "Mon, Feb 27th, 11:46am - 12:00pm",
        speakers: "Andras Hortinson",
        format: "Test"
      }
    }
  ],
  instanceId: "session-97a0ede9-0697-4dec-8e35-f584921ceefd",
  sessionDataSelected: {},
  backgroundColor: "#fefefe"
};

const Sessions = () => (
  <Div px={4} py={3} display="column.flex-start.stretch" style={{ gap: "8px" }}>
    <Session {...DUMMY_SESSION_2} />
    <Session {...DUMMY_SESSION_2} />
  </Div>
);

export default Sessions;
